import { brandColors } from '@givebutter/util';
import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
`;

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding: 1.5rem;
    background: white;
    box-shadow: 0 2px 6px rgba(196, 207, 217, 0.5);
    border-radius: 0.5rem;
    flex-basis: 50%;
`;

export const CardHeader = styled.p`
    font-weight: 500;
    font-size: 15px;
    color: black;
    margin-bottom: 0.5rem;
`;

export const CardBody = styled.p`
    font-size: 15px;
    color: black;
    line-height: 1.5rem;
`;

export const CardAction = styled.button`
    align-self: end;
    border: none;
    padding: 0;
    background: none;
    color: ${brandColors.cobalt.primary};
    font-weight: 500;
    font-size: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all cubic-bezier(0.16, 0.8, 0.45, 1) 0.3s;

    :hover {
        color: ${brandColors.cobalt.dark};
    }
`;

export const CardLink = styled.a`
    align-self: end;
    border: none;
    padding: 0;
    background: none;
    color: ${brandColors.cobalt.primary};
    font-weight: 500;
    font-size: 15px;
    cursor: pointer;
    display: flex;
    align-items: center;
`;
